var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.137936 4.59144L3.73427 0.168562C3.91683 -0.0561873 4.2103 -0.0561873 4.39285 0.168562C4.57541 0.393311 4.57541 0.754598 4.39285 0.979347L1.59155 4.42806H17.5321C17.7906 4.42806 18 4.68579 18 5.00412C18 5.32322 17.7906 5.58095 17.5321 5.58095H1.59217L4.39348 9.02046C4.57604 9.24521 4.57604 9.6065 4.39348 9.83125C4.30189 9.94401 4.18413 10 4.06201 10C3.94051 10 3.82213 9.94401 3.73054 9.83125L0.133574 5.403C-0.0452465 5.18208 -0.0452458 4.81696 0.137936 4.59144Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.068b8da89d95bea3bab93d30e1d7c68a.svg";
export { ForwardRef as ReactComponent };